import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  TRANSACTIONS_PATH,
  TRANSACTIONS_DETAIL_PATH,
} from "utils/constants/paths";

const Transactions = Loadable(React.lazy(() => import("./View")));
const TransactionsDetail = Loadable(React.lazy(() => import("./View/Detail")));

export const TransactionsRoute: IRouteItem = {
  path: TRANSACTIONS_PATH,
  iconName: "MoneySend",
  element: React.createElement(Transactions),
  name: "Transactions",
  accessKeys: ["SuperAdmin", "Admin", "Analytics", "Support", "Manager"],
  children: [
    {
      path: `${TRANSACTIONS_DETAIL_PATH}/:id`,
      element: React.createElement(TransactionsDetail),
      showInDrawer: false,
    },
  ],
};
